import { render, staticRenderFns } from "./jifenshop.vue?vue&type=template&id=6aa94e95&scoped=true&"
import script from "./jifenshop.vue?vue&type=script&lang=js&"
export * from "./jifenshop.vue?vue&type=script&lang=js&"
import style0 from "./jifenshop.vue?vue&type=style&index=0&id=6aa94e95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa94e95",
  null
  
)

export default component.exports